import {appUrl} from '@frontend/AppUrl'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Создание ссылки на страницу пользователя, который предоставляет услуги.
export function makeExecutorOwnerDetailsUrl(userId: number): string {
    return NavigationService.makeUrl(
        appUrl().services.ownerDetails,
        {id: userId}
    )
}
